import { Component, inject, OnInit } from '@angular/core';
import { logger, Utils } from 'src/app/utils';
import { ButtonComponent } from '@progress/kendo-angular-buttons';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { SVGIconComponent } from '@progress/kendo-angular-icons';
import { Icons } from 'src/app/icons';
import { ReplacePipe } from 'src/app/pipes/replace.pipe';
import { SpacerComponent } from 'src/app/ui/atoms/spacer/spacer.component';
import { PaymentService } from 'src/app/services/payment.service';
import { FormService } from 'src/app/services/form.service';
import { StepsService } from 'src/app/services/steps.service';
import { UrlService } from 'src/app/services/url.service';

@Component({
    selector: 'app-in-store-payment',
    imports: [
        ButtonComponent,
        TranslatePipe,
        SVGIconComponent,
        ReplacePipe,
        SpacerComponent
    ],
    templateUrl: './in-store-payment.component.html',
    styleUrl: './in-store-payment.component.scss'
})
export class InStorePaymentComponent implements OnInit {
  public icons = Icons;
  private urlService = inject(UrlService);
  private formService = inject(FormService);
  private stepsService = inject(StepsService);
  private translateService = inject(TranslateService);
  private paymentService = inject(PaymentService);

  hasError = false;

  contractId: string;
  pdfLink: string;

  mail: {subject: string, body: string} = {subject: '', body: ''};

  ngOnInit() {
    this.submit();
  }

  private submit() {
    this.paymentService.placeOrder(this.formService.form()).subscribe({
      next: (response: any) => {
        this.contractId = response;
        this.pdfLink = this.paymentService.generateReservationDownloadLink(this.contractId);
        this.hasError = false;

        this.mail = {
          subject: Utils.encodeMailURIString(
            this.translateService.instant('mail.subject').replace('[contractId]', this.contractId)
          ),
          body: Utils.encodeMailURIString(
            this.translateService.instant('mail.body').replace('[contractId]', this.contractId)
          )
        }

        logger.i('reservation response', response);
      },
      error: () => this.hasError = true,
    });
  }

  resetForm() {
    const targetUrlBase = this.urlService.getApplicationBaseUrl();
    const queryParams = new URLSearchParams(this.formService.params).toString();
    let finalUrl = targetUrlBase;
    if (environment.production) {
      if (queryParams.length > 0) finalUrl += '#/?' + queryParams;
    } else {
      if (queryParams.length > 0) finalUrl += '?' + queryParams;
    }
    window.location.href = finalUrl;
    window.location.reload();
  }

  back() {
    this.stepsService.previousStepHandler();
  }
}
